const ACCEPTED_KEYS = ['request_refund_message'];

export const translateMessage = (
  message: string,
  t: (key: string, params: Record<string, string>) => string
): string => {
  try {
    const messageObj = JSON.parse(message);

    if (messageObj.key && ACCEPTED_KEYS.includes(messageObj.key)) {
      return t(messageObj.key, messageObj.params);
    } else {
      return message;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return message;
  }
};
